module.exports = __webpack_public_path__ + "img/sequence-kyoto-gojo-sp.37234a3d.jpg";